import React from 'react';

export function checkPassword(pw) {
  return {
    len:   pw.length >= 8,
    upper: /[A-Z]/.test(pw),
    lower: /[a-z]/.test(pw),
    num:   /[0-9]/.test(pw),
    sym:   /[^A-Za-z0-9]/.test(pw),
  };
}

export function validatePassword(pw) {
  const c = checkPassword(pw);
  if (!c.len)   return 'Must be at least 8 characters';
  if (!c.upper) return 'Must contain an uppercase letter';
  if (!c.lower) return 'Must contain a lowercase letter';
  if (!c.num)   return 'Must contain a number';
  if (!c.sym)   return 'Must contain a symbol (!@#$% etc.)';
  return null;
}

export default function PasswordStrength({ password }) {
  if (!password) return null;
  const c = checkPassword(password);
  const score = Object.values(c).filter(Boolean).length;
  const colors = ['', '#ef4444','#ef4444','#f59e0b','#f59e0b','#22c55e'];
  const labels = ['','Weak','Weak','Fair','Good','Strong'];
  const rules = [
    { key:'len',   label:'8+ characters' },
    { key:'upper', label:'Uppercase letter' },
    { key:'lower', label:'Lowercase letter' },
    { key:'num',   label:'Number' },
    { key:'sym',   label:'Symbol' },
  ];
  return (
    <div style={{ marginTop:8 }}>
      <div className="strength-bars">
        {[1,2,3,4,5].map(i => (
          <div key={i} className="strength-bar"
            style={{ background: i <= score ? colors[score] : 'var(--border)' }} />
        ))}
      </div>
      {score > 0 && <div style={{ fontSize:11, color: colors[score], fontWeight:600, marginTop:4 }}>{labels[score]}</div>}
      <div className="strength-rules" style={{ marginTop:6 }}>
        {rules.map(r => (
          <div key={r.key} className="strength-rule">
            <span style={{ color: c[r.key] ? '#22c55e' : 'var(--border)', fontSize:13 }}>{c[r.key] ? '✓' : '○'}</span>
            <span style={{ color: c[r.key] ? '#15803d' : 'var(--text2)' }}>{r.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
